import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  toppingList: {
    display: 'flex',
    gap: '1rem',
    flexDirection: 'column',
    '&:not([data-toppings-level="0"])': {
      marginTop: '0.25rem',
    },
    '&:has(> :first-child > :first-child:not([aria-label="category-name"]))': {
      marginTop: '0.5rem',
    },
  },
  topping: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    listStyle: 'none',
    '& > [aria-label="category-name"]': {
      marginLeft: '2.5rem',
      fontWeight: 600,
      fontSize: '0.75rem',
      lineHeight: '1rem',
      letterSpacing: '1.2px',
      color: neutral[60],
    },
  },
  toppingInfo: {
    width: '100%',
    display: 'flex',
    columnGap: '1rem',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: '1.5rem',
  },
});
